<template>
    <div>
        <UploadCSV />
        <iframe name="hiddenframe" hidden></iframe>
    </div>
</template>
<script>
import UploadCSV from "../../components/Upload/UploadCSV.vue";

export default {
    components: {
        UploadCSV
    }
}
</script>